import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PatrolGroupService {

  // 固定参数
  private uri = 'plan/api/business/patrolGroup';

  constructor(private httpClient: HttpClient) { }
    // 根据过滤字符串查询巡检组
  getGroupsByFilterString(egLike): Observable<any[]> {
    const url = 'plan/api/business/patrolGroup/groupsByFilterString?egLike=' + egLike;
    return this.httpClient.get(url).pipe(
      map((res: {data: any[]}) => res.data)
    );
  }
  // 获取所有巡检组
  getGroups(groupType?: number): Observable<any[]> {
    if (groupType == null || groupType === undefined){
      return this.httpClient.get('plan/api/business/patrolGroup/groups').pipe(
        map((res: {data: any[]}) => res.data)
      );
    }else{
      return this.httpClient.get(`plan/api/business/patrolGroup/groups/${groupType}`).pipe(
        map((res: {data: any[]}) => res.data)
      );
    }
  }
  /**
   * 查询巡检组列表
   */
  async queryGroupDataByCondition(param: any, pageNum: number, pageSize: number) {
    let url = 'plan/api/business/patrolGroup/allGroupByCondition' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize;
    if (param.groupName == null || param.groupName === undefined || param.groupName === '') {
    } else {
      url = url + '&groupName=' + param.groupName;
    }
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }
  /**
   * 根据巡检组编号查询子项列表
   */
  async getAllItemsFromGroup(param: any, pageNum: number, pageSize: number, groupType: any) {
    const url = 'plan/api/business/patrolGroup/allItemsFromGroup' + '?pageNum=' + pageNum +
      '&pageSize=' + pageSize + '&groupNo=' + param + '&groupType=' + groupType;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }
  /**
   * 添加巡检组
   */
  async addGroup(group: any) {
    return await this.httpClient.post(this.uri + '/add', group).toPromise();
  }
  /**
   * 修改巡检组
   */
  async editGroup(group: any) {
    return await this.httpClient.post(this.uri + '/edit', group).toPromise();
  }
  /**
   * 删除巡检组
   */
  async deleteGroup(group: any) {
    return await this.httpClient.post(this.uri + '/delete', group).toPromise();
  }
  /**
   * 通过组名称查询巡检组列表
   */
  async queryGroupByName(name: any) {
    const url = 'plan/api/business/patrolGroup/queryGroupByName/' + name;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }
  /**
   * 通过组Id查询巡检组
   */
   async queryGroupById(id: any) {
    const url = 'plan/api/business/patrolGroup/queryGroupById/' + id;
    const ret: any = await this.httpClient.get(url).toPromise();
    return ret;
  }
  /**
   * 更新巡检组中数据
   */
   updateItemsInGroup(data: any) {
    return this.httpClient.post(this.uri + '/updateItemsInGroup', data);
  }
}
